import { formatStock, OrderItemForExcel } from "../../domain/Product";
import OrderDraft, {
  ArticleOrderDraft,
  ItemOrderDraft,
} from "../../domain/Order";
import { formatPrice } from "../formatNumber";

export interface Product {
  categories: string;
  articleName: string;
  articleId: string;
  sku: string;
  variantCode: string;
  ean: string;
  eanPack?: string;
  size: string;
  price: number;
  packageSize: number;
  estimatedQty: number;
  ordered: number;
  liabilityMet: string;
  availableStock: number;
  season?: string;
  isCollab?: string;
  collectionSegment?: string;
  assortmentSegment?: string;
}

export default (products: Product[], order: OrderDraft): OrderItemForExcel[] =>
  products.map((product: Product) => {
    const orderArticle = order.articlesOrdersDrafts.find(
      (article: ArticleOrderDraft) => article.articleId === product.articleId
    );
    if (orderArticle) {
      const orderItem:
        | ItemOrderDraft
        | undefined = orderArticle.itemsOrdersDrafts.find(
        (item: ItemOrderDraft) => item.sku === product.sku
      );
      if (orderItem) {
        return {
          ...product,
          estimatedQty: product.estimatedQty.toString(),
          ordered: product.ordered.toString(),
          availableStock: formatStock(product.availableStock).toString(),
          price: formatPrice(product.price),
          month: orderItem.toOrderFromEstimation,
          stockOrder: orderItem.toOrderFromStock,
        };
      } else {
        // todo not tested
        return createEmpty(product);
      }
    } else {
      return createEmpty(product);
    }
  });

const createEmpty = (product: Product): OrderItemForExcel => {
  return {
    ...product,
    estimatedQty: product.estimatedQty.toString(),
    ordered: product.ordered.toString(),
    availableStock: formatStock(product.availableStock).toString(),
    price: formatPrice(product.price),
    month: 0,
    stockOrder: 0,
  };
};



// WEBPACK FOOTER //
// ./src/view/order/createDataForExcel.ts